import { __generator } from "tslib";
import { getAspectRatio } from '@marvelapp/core';
import { call, select, takeLatest } from 'redux-saga/effects';
import { preloadImages, getFormattedImageUrl } from '../utils/image';
import * as actionCreators from '../actionCreators';
import * as actionTypes from '../constants/actionTypes';
import { IMAGE_PRELOAD_BATCH_SIZE } from '../constants/screen';
import { getFrame, getOrientation, isOpen as isGridOpen } from '../selectors';
var actions = [actionTypes.LOAD_FULL_PROJECT_DONE, actionTypes.SHOW_GRID];
export default function loadThumbnails(dispatch) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // TODO: in the future we will need to support
            // partial project loading on embedded prototypes
            return [4 /*yield*/, takeLatest(actions, function (action) {
                    var showGrid, project, frame, orientation, frameAspectRatio, loadThumbs, isLoaded_1, imageThumbs, images;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(action.type === actionTypes.LOAD_FULL_PROJECT_DONE)) return [3 /*break*/, 2];
                                return [4 /*yield*/, select(isGridOpen)];
                            case 1:
                                showGrid = _a.sent();
                                if (!showGrid) {
                                    return [2 /*return*/];
                                }
                                _a.label = 2;
                            case 2: return [4 /*yield*/, select(function (state) { return state.project; })];
                            case 3:
                                project = _a.sent();
                                return [4 /*yield*/, select(function (state) { return getFrame(state); })];
                            case 4:
                                frame = _a.sent();
                                return [4 /*yield*/, select(function (state) { return getOrientation(state); })];
                            case 5:
                                orientation = _a.sent();
                                frameAspectRatio = getAspectRatio(frame, orientation);
                                return [4 /*yield*/, select(function (state) { return !(state.deviceDetection.isMobile || project.isEmbedded); })];
                            case 6:
                                loadThumbs = _a.sent();
                                if (!loadThumbs) return [3 /*break*/, 10];
                                return [4 /*yield*/, select(function (state) { return state.grid.isThumbLoaded; })];
                            case 7:
                                isLoaded_1 = _a.sent();
                                imageThumbs = project.config.screens
                                    .filter(function (_a) {
                                    var id = _a.id;
                                    return !isLoaded_1[id];
                                })
                                    .map(function (screen) { return ({
                                    id: screen.id,
                                    url: getFormattedImageUrl(screen.img, 320, frameAspectRatio),
                                }); });
                                _a.label = 8;
                            case 8:
                                if (!(imageThumbs.length > 0)) return [3 /*break*/, 10];
                                images = imageThumbs.splice(0, IMAGE_PRELOAD_BATCH_SIZE);
                                return [4 /*yield*/, call(preloadImages, {
                                        dispatch: dispatch,
                                        images: images,
                                        successActionCreator: actionCreators.imageThumbLoaded,
                                        failureActionCreator: actionCreators.imageThumbFailed,
                                    })];
                            case 9:
                                _a.sent();
                                return [3 /*break*/, 8];
                            case 10: return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                // TODO: in the future we will need to support
                // partial project loading on embedded prototypes
                _a.sent();
                return [2 /*return*/];
        }
    });
}
